import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useT } from "@/i18n";
import api, { formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ResetPassword() {
  const t = useT();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success(t("rpw.done"));
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || t("rpw.title")); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex items-center gap-2 font-heading font-extrabold text-xl"><Logo size={24} className="text-brand-yellow" /> KIHAP</div>
        <h2 className="font-heading text-2xl font-bold">{t("rpw.title")}</h2>
        {!token ? (
          <p className="text-sm text-destructive">{t("rpw.invalid")}</p>
        ) : done ? (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">{t("rpw.done")}</p>
            <Button onClick={() => nav("/login")} className="w-full" data-testid="reset-to-login">{t("login.enter")}</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div className="space-y-2">
              <Label>{t("acct.newPw")}</Label>
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-new-pw" />
            </div>
            <Button type="submit" className="w-full" disabled={pw.length < 6} data-testid="reset-submit">{t("rpw.submit")}</Button>
            <p className="text-xs text-muted-foreground text-center"><Link to="/login" className="underline">{t("login.enter")}</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
